import {
  skipToken,
  useSuspenseQuery as useSuspenseQueryOriginal,
} from '@apollo/client';

// This hook is used wherever we need to load API data from Apollo Client.
const useSuspenseQuery = (query, originalOptions) => {
  // If skip is truthy or it is during the build phase, pass skipToken to skip
  // the query.
  const options = originalOptions?.skip ? skipToken : originalOptions;

  return useSuspenseQueryOriginal(query, options);
};

export default useSuspenseQuery;
